export function formatElapsedTime(seconds: number): string {
    if (seconds < 60) {
        return `${seconds} second${seconds !== 1 ? "s" : ""}`
    } else {
        const minutes = Math.floor(seconds / 60)
        const remainingSeconds = seconds % 60
        const minuteText = `${minutes} minute${minutes !== 1 ? "s" : ""}`
        const secondText = `${remainingSeconds} second${remainingSeconds > 1 ? "s" : ""}`
        return `${minuteText} ${secondText}`
    }
}